import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import "./homeUnverified.css";
import { utils } from "../../../utils/Utils.jsx";
import { HiIdentification, HiPhone } from "react-icons/hi2";
import { MdEmail } from "react-icons/md";

function HomeUnverified(props) {
  const [isMobileWidth, setIsMobileWidth] = useState(false);

  useEffect(() => {
    const resizeHandler = () => {
      utils.checkWindowWidth(
        (state) => setIsMobileWidth(state.isMobileWidth),
        props.changeGoBackNavBar,
        false,
        null,
      );
    };

    resizeHandler();
    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);

  const goToURL = (url) => {
    utils.goToURL(props, url);
  };

  const getPendingVerifications = () => {
    const pending = [];

    if (!props.phoneValidated) {
      pending.push({
        icon: <HiPhone className="verification-icon" />,
        title: props.localizedText["phone-verification"],
        description:
          props.localizedText[
            "confirm-your-phone-number-to-secure-your-account"
          ],
        primaryButton: {
          text: props.localizedText["verify-phone"],
          url: "/dashboard/settings/verify-phone",
        },
        secondaryButton: {
          text: props.localizedText["change-phone-number"],
          url: "/dashboard/settings/change-phone",
        },
      });
    }

    if (!props.emailValidated) {
      pending.push({
        icon: <MdEmail className="verification-icon" />,
        title: props.localizedText["email-verification"],
        description:
          props.localizedText[
            "confirm-your-email-address-to-receive-notifications"
          ],
        primaryButton: {
          text: props.localizedText["verify-email"],
          url: "/dashboard/settings/verify-email",
        },
        secondaryButton: {
          text: props.localizedText["change-email"],
          url: "/dashboard/settings/change-email",
        },
      });
    }

    if (!props.idValidated) {
      pending.push({
        icon: <HiIdentification className="verification-icon" />,
        title: props.localizedText["identity-verification"],
        description:
          props.localizedText["verify-your-identity-to-unlock all features"],
        primaryButton: {
          text: props.localizedText["verify-id"],
          url: "/dashboard/settings/id-verification",
        },
      });
    }

    return pending;
  };

  const pendingVerifications = getPendingVerifications();

  return (
    <React.Fragment>
      <div class="middle-container home-unverified-container page-container">
        <div class="form-container">
          <div class="main-title">
            {props.localizedText["complete-registration"]}
          </div>
          <div class="page-subtitle">
            {props.localizedText[
              "in-order-to-deposit,-withdraw-and-make-payments,-please-complete-your-registration-by"
            ] + ":"}
          </div>

          <div class="verifications-div fade-in-up">
            {pendingVerifications.map((item) => (
              <div
                class="content-container-no-hover verification-item"
                key={item.primaryButton.url}
              >
                <div class="verification-info">
                  {item.icon}
                  <div class="verification-text">
                    <div class="verification-title">{item.title}</div>
                    <div class="verification-description">
                      {item.description}
                    </div>
                  </div>
                </div>
                <div
                  class="verification-buttons"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <button
                    class="primary-button outside-primary-button"
                    onClick={() => goToURL(item.primaryButton.url)}
                  >
                    {item.primaryButton.text}
                  </button>
                  {item.secondaryButton && (
                    <button
                      class="secondary-button"
                      onClick={() => goToURL(item.secondaryButton.url)}
                    >
                      {item.secondaryButton.text}
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default withRouter(HomeUnverified);
